import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "../AudioManager";
import { MessageManager } from "./MessageManager";

export class Message extends Phaser.Group {

    public static GOAL = "goal";
    public static EXTRA_GOAL = "extra goal";
    public static STREAKER = "streaker";
    public static THREE_BALLS_LEFT = "three balls left";
    public static EXTRA_BALLS = "extra balls";
    public static TIMED_LEVEL = "timed level";
    public static TIME_UP = "time up";
    public static VOODOO = "voodoo";
    public static BALL_OF_FIRE = "ball of fire";
    public static FREEZE_GOALKEEPER = "freeze goalkeeper";
    public static PENALTY_SCORED = "penalty goal";

    private static SCORE_LABEL_FONT_SIZE = 60;
    private static SCORE_LABEL_GOAL_PY = -110;
    private static SCORE_LABEL_EXTRA_GOAL_PY = -125;

    private messageSprite: Phaser.Image;
    private messageContainer: Phaser.Group;
    private msgType: string;
    private timeLabel: Phaser.Text;
    private scoreLabelGroup: Phaser.Group;
    private scoreLabel: Phaser.Text;
    private confettiAnimation: Phaser.Sprite;

    constructor(game: Phaser.Game) {

        super(game, null, "message", false);

        this.scale.y = GameVars.scaleY;

        this.confettiAnimation = null;
        this.timeLabel = null;

        this.messageContainer = new Phaser.Group(this.game);
        this.messageContainer.x = GameConstants.GAME_WIDTH / 2;
        this.messageContainer.y = 500;
        this.messageContainer.scale.y = GameVars.scaleY;
        this.add(this.messageContainer);

        this.scoreLabelGroup = new Phaser.Group(this.game);
        this.messageContainer.add(this.scoreLabelGroup);

        this.messageSprite = new Phaser.Sprite(game, 0, 0, "texture_atlas_1");
        this.messageSprite.anchor.set(.5);
        this.messageContainer.add(this.messageSprite);

        var rays = new Phaser.Image(this.game, 0, -60, "texture_atlas_1", "rays");
        rays.anchor.setTo(.5);
        rays.scale.setTo(1.75, 1.75);
        rays.alpha = .8;
        this.scoreLabelGroup.add(rays);

        this.scoreLabel = new Phaser.Text(this.game, 0, 0, "", { font: Message.SCORE_LABEL_FONT_SIZE + "px futura-bold", fill: "#D8102D" });
        this.scoreLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        this.scoreLabel.anchor.x = .5;
        this.scoreLabelGroup.add(this.scoreLabel);

        this.scoreLabelGroup.visible = false; // no se hace invisible al hacer la clase invisible

        this.visible = false;
    }

    public show(msgType: string): void {

        this.msgType = msgType;

        var initialScale: number;
        var finalScale: number;
        var tweenType: Function;
        var alphaTweenDelay: number;
        var audioEffect: string = null;

        var tweenDuration: number;

        if (this.msgType === Message.GOAL || this.msgType === Message.EXTRA_GOAL) {

            initialScale = 0;
            finalScale = 2;
            tweenType = Phaser.Easing.Bounce.Out;
            tweenDuration = 400;
            alphaTweenDelay = 3000;

            this.scoreLabelGroup.visible = true;

            this.scoreLabel.text = (GameVars.playerGoals - 1) + "-" + GameVars.adversaryGoals;

            if (this.msgType === Message.GOAL) {
                this.messageSprite.frameName = "msg-goal";
                this.scoreLabel.y = Message.SCORE_LABEL_GOAL_PY;
            } else {
                this.messageSprite.frameName = "msg-extra-goal";
                this.scoreLabel.y = Message.SCORE_LABEL_EXTRA_GOAL_PY;
            }

            if (GameVars.playerGoals === GameVars.adversaryGoals + 1) {

                // poner la animacion del confetti en el scoreLabelGroup por detras
                audioEffect = "super_goal";

                this.confettiAnimation = new Phaser.Sprite(this.game, 0, -12, "texture_atlas_2");
                this.confettiAnimation.animations.add("animation", Phaser.Animation.generateFrameNames("gol_victoria_", 1, 11, "", 4));
                this.confettiAnimation.animations.play("animation", 10, false, true);
                this.confettiAnimation.anchor.set(.5);
                this.confettiAnimation.scale.set(1.45);
                this.scoreLabelGroup.addChildAt(this.confettiAnimation, 0);

            } else {

                let rnd = Math.random();

                if (rnd > .75) {
                    audioEffect = "goal_1";
                } else if (rnd > .5) {
                    audioEffect = "goal_2";
                } else if (rnd > .25) {
                    audioEffect = "goal_3";
                } else {
                    audioEffect = "goal_4";
                }
            }

            // poner lo del pato - si es el ultimo gol que da la victoria
            // y el portero es pato no hacer sonido alguno
            if (GameVars.playerGoals > GameVars.adversaryGoals
                && GameVars.balls === 0
                && GameVars.isGoalKeeperDuck) {
                audioEffect = null;
            }

            // lanzar un evento para actualizar el contador
            this.game.time.events.add(800, this.updateScoreLabel, this);

        } else if (this.msgType === Message.PENALTY_SCORED) {

            initialScale = 0;
            finalScale = 2;
            tweenType = Phaser.Easing.Bounce.Out;
            tweenDuration = 400;
            alphaTweenDelay = 2000;

            this.messageSprite.frameName = "msg-goal";

            this.scoreLabelGroup.visible = true;
            this.scoreLabel.visible = false;

            // poner la animacion del confetti en el scoreLabelGroup por detras
            this.confettiAnimation = new Phaser.Sprite(this.game, 0, -12, "texture_atlas_2");
            this.confettiAnimation.animations.add("animation", Phaser.Animation.generateFrameNames("gol_victoria_", 1, 11, "", 4));
            this.confettiAnimation.animations.play("animation", 10, false, true);
            this.confettiAnimation.anchor.set(.5);
            this.confettiAnimation.scale.setTo(1.45);
            this.scoreLabelGroup.addChildAt(this.confettiAnimation, 0);

            audioEffect = "super_goal";

        } else if (this.msgType === Message.STREAKER) {

            initialScale = 0;
            finalScale = 2;
            tweenType = Phaser.Easing.Bounce.Out;
            tweenDuration = 400;
            alphaTweenDelay = 1500;
            this.messageSprite.frameName = "msg-streaker";

        } else if (this.msgType === Message.THREE_BALLS_LEFT) {

            initialScale = 5;
            finalScale = 2;
            tweenType = Phaser.Easing.Cubic.Out;
            tweenDuration = 400;
            alphaTweenDelay = 1750;
            this.messageSprite.frameName = "msg-3-balls-left";

        } else if (this.msgType === Message.EXTRA_BALLS) {

            initialScale = 0;
            finalScale = 2;
            tweenType = Phaser.Easing.Bounce.Out;
            alphaTweenDelay = 1500;
            this.messageSprite.frameName = "msg-extra-balls";

        } else if (this.msgType === Message.TIMED_LEVEL) {

            initialScale = 5;
            finalScale = 1.5;
            tweenType = Phaser.Easing.Cubic.Out;
            tweenDuration = 600;
            alphaTweenDelay = 5000;
            this.messageSprite.frameName = "msg-extra-time";

            this.timeLabel = new Phaser.Text(this.game, 0, 75,
                " " + GameVars.time + "S ", { font: "65px whoopass", fill: "#DAE9E9" });
            this.timeLabel.anchor.x = .5;
            this.timeLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            this.messageContainer.addChild(this.timeLabel);

        } else if (this.msgType === Message.TIME_UP) {

            initialScale = 5;
            finalScale = 2.5;
            tweenType = Phaser.Easing.Cubic.Out;
            tweenDuration = 400;
            alphaTweenDelay = 6000;
            this.messageSprite.frameName = "msg-time-up";

            audioEffect = "3_silvatos";

        } else if (this.msgType === Message.VOODOO) {

            initialScale = 5;
            finalScale = 2.5;
            tweenType = Phaser.Easing.Quadratic.Out;
            tweenDuration = 400;
            alphaTweenDelay = 2500;
            this.messageSprite.frameName = "msg-voodoo";

        } else if (this.msgType === Message.FREEZE_GOALKEEPER) {

            initialScale = 5;
            finalScale = 2.5;
            tweenType = Phaser.Easing.Quadratic.Out;
            tweenDuration = 400;
            alphaTweenDelay = 1750;
            this.messageSprite.frameName = "msg-freeze-goalkeeper";

        } else if (this.msgType === Message.BALL_OF_FIRE) {

            initialScale = 0;
            finalScale = 2.5;
            tweenType = Phaser.Easing.Quadratic.Out;
            tweenDuration = 400;
            alphaTweenDelay = 1500;
            this.messageSprite.frameName = "msg-ball-of-fire";
        }

        // si es un nivel de prorroga hacer que el mensaje desaparezca antes
        if (GameVars.isTimedLevel) {
            alphaTweenDelay = alphaTweenDelay * .45;
        }

        this.visible = true;

        this.messageContainer.alpha = 1;
        this.messageContainer.scale.setTo(initialScale);

        this.game.add.tween(this.messageContainer.scale)
            .to({ x: finalScale, y: finalScale }, tweenDuration, tweenType, true);

        this.game.add.tween(this.messageContainer)
            .to({ alpha: 0 }, tweenDuration, Phaser.Easing.Quadratic.Out, true, alphaTweenDelay)
            .onComplete.add(this.removeMessage, this);

        if (audioEffect !== null) {
            AudioManager.getInstance().playEffect(audioEffect);
        }
    }

    private removeMessage(): void {

        this.visible = false;

        if (this.msgType === Message.GOAL || this.msgType === Message.EXTRA_GOAL) {
            this.scoreLabelGroup.visible = false;
        }

        if (this.msgType === Message.TIMED_LEVEL) {
            if (this.timeLabel) {
                this.timeLabel.destroy();
            }
        }

        MessageManager.currentInstance.onMessageRemoved();
    }

    private updateScoreLabel(): void {

        if (GameVars.playerGoals > GameVars.adversaryGoals || GameVars.playerGoals === GameVars.adversaryGoals) {

            this.scoreLabel.destroy();

            var fontColor: string;
            var label_py: number;

            if (GameVars.playerGoals > GameVars.adversaryGoals) {
                fontColor = "#2BB740";
                label_py = Message.SCORE_LABEL_EXTRA_GOAL_PY;
            } else {
                fontColor = "#FF7505";
                label_py = Message.SCORE_LABEL_GOAL_PY;
            }

            this.scoreLabel = new Phaser.Text(this.game, 0, label_py,
                GameVars.playerGoals.toString() + "-" + GameVars.adversaryGoals, { font: Message.SCORE_LABEL_FONT_SIZE + "px futura-bold", fill: fontColor });
            this.scoreLabel.anchor.x = .5;
            this.scoreLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            this.scoreLabelGroup.add(this.scoreLabel);
        }

        this.scoreLabel.text = GameVars.playerGoals.toString() + "-" + GameVars.adversaryGoals;
        this.scoreLabel.anchor.x = .5;
    }
}
